var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-app",
    {
      class: [
        "app min-h-smallest bg-white xs:px-0 sm:px-1 mdAndUp:px-3",
        _vm.$page.component == "Explore" ? "bg-gradient-a" : null,
      ],
    },
    [
      _c("Head", { attrs: { title: _vm.tabTitle } }),
      _vm._v(" "),
      _vm.$page.props.impersonating?.impersonatingUser &&
      !_vm.showBanner?.some((e) => e.show)
        ? _c(
            "v-system-bar",
            {
              staticClass: "gradient-blue white--text justify-center",
              attrs: { app: "", height: "64" },
            },
            [
              _c(
                "div",
                { staticClass: "flex justify-center" },
                [
                  _c("v-card-subtitle", { staticClass: "align-self-center" }, [
                    _vm._v(
                      "\n                " +
                        _vm._s(
                          `Impersonating ${this.$page.props.auth.user.name}`
                        ) +
                        "\n            "
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      staticClass: "my-3",
                      attrs: { color: "white", plain: "" },
                      on: {
                        click: function ($event) {
                          return _vm.stopImpersonating()
                        },
                      },
                    },
                    [_vm._v("\n                Return\n            ")]
                  ),
                ],
                1
              ),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      (_vm.showBanner ? _vm.showBanner.some((e) => e.show) : false)
        ? _c(
            "v-system-bar",
            {
              staticClass: "gradient-orange white--text justify-center",
              attrs: { app: "", height: "128" },
            },
            [
              _c(
                "div",
                [
                  _c("v-card-subtitle", { staticClass: "pb-0" }, [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.showBanner.find((e) => e.show).message) +
                        "\n            "
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "v-card-actions",
                    { staticClass: "justify-end" },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: { color: "white", text: "" },
                          on: {
                            click: function ($event) {
                              _vm.showBanner.find((e) => e.show).addCreditCard
                                ? _vm.addCreditCard()
                                : _vm.pastDueInvoice(
                                    _vm.showBanner.find((e) => e.show).invoice
                                  )
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n                    " +
                              _vm._s(
                                _vm.showBanner.find((e) => e.show).button
                              ) +
                              "\n                "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      false
        ? _c(
            "v-system-bar",
            {
              staticClass: "gradient-orange white--text justify-center",
              attrs: { app: "", height: "64" },
            },
            [
              _c(
                "div",
                [
                  _c("v-card-subtitle", [
                    _vm._v(
                      "\n                Network error detected. No offline access.\n            "
                    ),
                  ]),
                ],
                1
              ),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.$page.props.version?.outage
        ? _c(
            "v-system-bar",
            {
              staticClass: "gradient-orange white--text justify-center",
              attrs: { app: "", height: "64" },
            },
            [
              _c(
                "div",
                [
                  _c("v-card-subtitle", [
                    _vm._v(
                      "\n                Temporary service outage. This app might not work as\n                expected. Thanks!\n            "
                    ),
                  ]),
                ],
                1
              ),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.$page.props.profileRequired &&
      !_vm.$page.props.impersonating?.impersonatingUser &&
      _vm.$page.props.auth.user &&
      _vm.$page.component !== "Store"
        ? _c(
            "v-system-bar",
            {
              staticClass: "gradient-orange white--text justify-center",
              attrs: { app: "", height: "64" },
            },
            [
              _c(
                "Link",
                {
                  staticClass: "flex align-center justify-center",
                  staticStyle: { cursor: "pointer" },
                  attrs: {
                    href: `/profile/${_vm.$page.props.auth?.user?.id}/personal-info`,
                  },
                },
                [
                  _c(
                    "v-progress-circular",
                    {
                      attrs: {
                        size: 42,
                        value: _vm.$page.props.profileComplete,
                        color: "white",
                      },
                    },
                    [
                      _c("small", [
                        _vm._v(_vm._s(_vm.$page.props.profileComplete) + "%"),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "v-card-subtitle",
                    { staticClass: "white--text" },
                    [
                      _vm._v("\n                Complete your profile"),
                      _c("v-icon", { attrs: { color: "white", large: "" } }, [
                        _vm._v("chevron_right"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.$vuetify.breakpoint.mdAndUp &&
      _vm.page !== "/login" &&
      _vm.$page.props.staffView
        ? _c("Sidenav", {
            attrs: {
              page: _vm.page,
              showMacros: _vm.showMacros,
              unreadMessageCount: _vm.unreadMessageCount,
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.siteHeader
        ? _c(
            "v-app-bar",
            {
              class: [
                "justify-end align-center flex px-0 py-0",
                !_vm.$page.props.staffView ? "container" : null,
              ],
              attrs: {
                app: "",
                color: "white",
                height: "100",
                "elevate-on-scroll": "",
              },
            },
            [
              _c(
                "a",
                { attrs: { href: "https://musicologielessons.com" } },
                [
                  _c("jet-application-logo", {
                    staticClass: "block h-9 w-auto",
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c("v-spacer"),
              _vm._v(" "),
              _c(
                "SoliBtn",
                {
                  staticStyle: { color: "white !important" },
                  attrs: { gradient: "gradient-orange", href: "/login" },
                },
                [_vm._v("Login")]
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.siteHeader && _vm.page !== "/profile" && _vm.page !== "/login"
        ? _c(
            "Navbar",
            {
              ref: "navBar",
              staticClass: "xs:px- sm:px-1 lg:px-2",
              attrs: {
                pageTitle: _vm.pageTitle,
                backLink: _vm.backLink,
                tabs: _vm.tabs,
                cart: _vm.cart,
                filterData: _vm.filterData,
                headerButton: _vm.headerButton,
                sandwich: _vm.sandwich,
                nearMe: _vm.nearMe,
                market: _vm.market,
                marketOptions: _vm.marketOptions,
                retentionGroup: _vm.retentionGroup,
                showArchived: _vm.showArchived,
                showAllStudents: _vm.showAllStudents,
                showMacros: _vm.showMacros,
              },
              on: {
                showCart: function ($event) {
                  return _vm.$emit("showCart")
                },
                locationSelect: function ($event) {
                  _vm.locationSelect = true
                },
                headerButton: function ($event) {
                  return _vm.$emit("headerButton")
                },
                pageSearch: function ($event) {
                  return _vm.$emit("pageSearch", $event)
                },
                filterResults: function ($event) {
                  ;[(_vm.filter = $event), _vm.$emit("filterResults", $event)]
                },
                quickLinks: function ($event) {
                  _vm.quickLinks = true
                },
                sandwich: function ($event) {
                  return _vm.$emit("sandwich")
                },
                success: function ($event) {
                  _vm.showMessage = true
                },
              },
            },
            [
              _c("template", { slot: "title" }, [_vm._t("title")], 2),
              _vm._v(" "),
              _c("template", { slot: "tabs" }, [_vm._t("tabs")], 2),
              _vm._v(" "),
              _c("template", { slot: "actions" }, [_vm._t("actions")], 2),
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "v-main",
        {
          class: [
            _vm.$page.component == "Schedule" ||
            _vm.$page.url.includes("/availability")
              ? "no-bottom-padding"
              : null,
          ],
        },
        [
          _c(
            "div",
            {
              class: [
                "h-full xs:px-0 lg:px-2 xs:py-0 md:py-1",
                _vm.page == "/schedule" ||
                _vm.$page.url.includes("/availability")
                  ? "sm:px-0"
                  : "sm:px-1",
              ],
              attrs: { fluid: "" },
            },
            [_vm._t("default")],
            2
          ),
          _vm._v(" "),
          !_vm.$vuetify.breakpoint.smAndDown && _vm.showFab
            ? _c("SoliBtn", {
                class: [
                  _vm.selectedPeople.length
                    ? "shadow-blue-xl"
                    : "shadow-orange-xl",
                  _vm.fabClasses,
                ],
                attrs: {
                  fab: "",
                  fixed: "",
                  right: "",
                  bottom: "",
                  round: "",
                  loading: _vm.fabLoading,
                  icon:
                    _vm.fabIcon ??
                    (_vm.selectedPeople.length ? "email" : "add"),
                  gradient: _vm.selectedPeople.length
                    ? "gradient-blue"
                    : "gradient-orange",
                },
                on: {
                  click: function ($event) {
                    return _vm.$emit("fabAction")
                  },
                },
              })
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _vm.siteFooter
        ? _c(
            "v-footer",
            { staticClass: "justify-center", attrs: { height: "50" } },
            [
              _c("div", { staticClass: "subtitle-center" }, [
                _vm._v(
                  "\n            © " +
                    _vm._s(new Date().getFullYear()) +
                    " · Musicologie\n        "
                ),
              ]),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "v-slide-y-reverse-transition",
        [
          _c(
            "v-footer",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.showFooter,
                  expression: "showFooter",
                },
              ],
              class: ["safe-bottom"],
              staticStyle: { height: "auto", "z-index": "9" },
              attrs: { fixed: "" },
            },
            [
              _c(
                "div",
                {
                  class: [
                    "justify-end align-center flex",
                    !_vm.$page.props.staffView ? "container" : null,
                  ],
                  staticStyle: { width: "100%", height: "56px" },
                },
                [
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c("SoliBtn", {
                    staticClass: "mr-4",
                    attrs: {
                      color: "grey darken-1",
                      text: "Cancel",
                      icon: "cancel",
                    },
                    on: {
                      click: function ($event) {
                        return _vm.$emit("cancel")
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c("SoliBtn", {
                    attrs: {
                      gradient: "gradient-orange",
                      text: "Save Changes",
                      icon: "save",
                      loading: _vm.submitProfileLoading,
                    },
                    on: {
                      click: function ($event) {
                        return _vm.$emit("save")
                      },
                    },
                  }),
                ],
                1
              ),
            ]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.$vuetify.breakpoint.smAndDown &&
      _vm.page !== "/login" &&
      _vm.$page.props.auth.user
        ? _c("BottomNav", {
            ref: "bottom-nav",
            attrs: {
              page: _vm.page,
              selectedPeople: _vm.selectedPeople,
              showFab: _vm.showFab,
              fabIcon: _vm.fabIcon,
              fabLoading: _vm.fabLoading,
              unreadMessageCount: _vm.unreadMessageCount,
            },
            on: {
              fabAction: function ($event) {
                return _vm.$emit("fabAction")
              },
              locationSelect: function ($event) {
                _vm.locationSelect = true
              },
              success: function ($event) {
                _vm.showMessage = true
              },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.locationSelect
        ? _c("SoliResponsiveDialog", {
            attrs: {
              title: _vm.studentLocations
                ? "Available Locations"
                : "Select Location",
            },
            on: {
              reset: function ($event) {
                ;[
                  (_vm.locationSelect = false),
                  (_vm.locationLoading = false),
                  (_vm.studentLocations = null),
                ]
              },
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "body",
                  fn: function () {
                    return [
                      _c("SoliUserLocation", {
                        ref: "userLocation",
                        attrs: {
                          locations: _vm.studentLocations
                            ? _vm.studentLocations
                            : _vm.$page.props.auth.user.locations,
                          loading: _vm.locationLoading,
                          iterator: "",
                          autofocus: "",
                        },
                        on: { input: _vm.updateSelectedLocation },
                        model: {
                          value: _vm.location,
                          callback: function ($$v) {
                            _vm.location = $$v
                          },
                          expression: "location",
                        },
                      }),
                    ]
                  },
                  proxy: true,
                },
              ],
              null,
              false,
              3721484844
            ),
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.showMessage
        ? _c("SoliSnack", {
            attrs: { time: 2000, text: _vm.$page.props.successMessage },
            on: {
              hide: function ($event) {
                _vm.showMessage = false
              },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.$page.props.errors.permissions
        ? _c("SoliSnack", {
            attrs: { text: _vm.$page.props.errors.permissions },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.updateAvailable
        ? _c("SoliSnack", {
            attrs: { text: "Update available!" },
            on: {
              hide: function ($event) {
                _vm.updateAvailable = false
              },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      !!_vm.$page.props.errors.contactSupport
        ? _c("SoliChoice", {
            attrs: {
              title: "Contact feedback@musicologie.com",
              subtitle: _vm.$page.props.errors.contactSupport,
              button1: "Okay",
            },
            on: {
              option1: function ($event) {
                return _vm.clearSupportError()
              },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      !!_vm.$page.props.errors.soliError
        ? _c("SoliChoice", {
            attrs: {
              title: "Uh oh",
              subtitle: _vm.$page.props.errors.soliError,
              button1: "Okay",
            },
            on: {
              option1: function ($event) {
                _vm.closeModal(() => (_vm.$page.props.errors.soliError = null))
              },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.$page.props.successData?.reminders
        ? _c(
            "SoliChoice",
            {
              attrs: {
                title: "Reminder",
                subtitle: _vm.$page.props.successData?.reminders.title,
                bold: "",
                button1: "Okay",
                permanent: "",
              },
              on: {
                option1: function ($event) {
                  _vm.closeModal(() => (_vm.$page.props.successData = null))
                },
              },
            },
            [
              _vm._l(
                _vm.$page.props.successData.reminders.data,
                function (reminders, idx) {
                  return _c(
                    "v-list-item",
                    {
                      key: idx,
                      staticClass: "soli-grey flex body-2",
                      attrs: { dense: "" },
                    },
                    [
                      _c(
                        "v-icon",
                        { staticClass: "mr-3", attrs: { color: "primary" } },
                        [_vm._v("task_alt")]
                      ),
                      _vm._v(_vm._s(reminders)),
                    ],
                    1
                  )
                }
              ),
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      !!_vm.$root.networkError
        ? _c("SoliChoice", {
            attrs: {
              title: "Uh oh",
              subtitle: "A network error has occurred",
              button1: "Okay",
            },
            on: {
              option1: function ($event) {
                _vm.closeModal(() => (_vm.$root.networkError = false))
              },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.confirmTimezone
        ? _c("SoliForm", {
            attrs: {
              title: "Confirm Timezone",
              textSubtitle: "Your timezone can be updated your preferences.",
              persistent: "",
              permanent: "",
            },
            on: {
              submit: function ($event) {
                return _vm.submitTimezone()
              },
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "body",
                  fn: function () {
                    return [
                      _c("v-select", {
                        attrs: {
                          items: _vm.timezones,
                          label: "Timezone",
                          "prepend-inner-icon": "watch",
                          outlined: "",
                          rules: [(v) => !!v || "Timezone is required"],
                          dense: "",
                        },
                        model: {
                          value: _vm.updateTimezone,
                          callback: function ($$v) {
                            _vm.updateTimezone = $$v
                          },
                          expression: "updateTimezone",
                        },
                      }),
                    ]
                  },
                  proxy: true,
                },
              ],
              null,
              false,
              702838732
            ),
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.confirmPreferences
        ? _c("SoliForm", {
            ref: "preferencesForm",
            attrs: {
              title: "Confirm Notification Preferences",
              textSubtitle:
                "SMS notifications are now available! Please update your preferences.",
              persistent: "",
              permanent: "",
            },
            on: {
              submit: function ($event) {
                return _vm.submitPreferences()
              },
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "body",
                  fn: function () {
                    return [
                      _c("NotificationPreferencesForm", {
                        model: {
                          value: _vm.notificationPreferences,
                          callback: function ($$v) {
                            _vm.notificationPreferences = $$v
                          },
                          expression: "notificationPreferences",
                        },
                      }),
                    ]
                  },
                  proxy: true,
                },
              ],
              null,
              false,
              2714172068
            ),
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.showNewFeatures
        ? _c("SoliForm", {
            ref: "features",
            attrs: {
              persistent: "",
              permanent: "",
              title: "Recent Updates and Features",
              text: "Finished",
              hideBtn: _vm.featureStep !== _vm.newFeatures.length,
              showCancelBtn: _vm.featureStep !== _vm.newFeatures.length,
            },
            on: {
              reset: function ($event) {
                _vm.showNewFeatures = false
              },
              submit: function ($event) {
                return _vm.closeNewFeatures()
              },
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "body",
                  fn: function () {
                    return [
                      _c(
                        "v-stepper",
                        {
                          staticClass: "soli-round",
                          model: {
                            value: _vm.featureStep,
                            callback: function ($$v) {
                              _vm.featureStep = $$v
                            },
                            expression: "featureStep",
                          },
                        },
                        _vm._l(_vm.newFeatures, function (feature) {
                          return _c(
                            "v-stepper-content",
                            {
                              key: feature.text,
                              attrs: { step: feature.step },
                            },
                            [
                              _c("v-img", {
                                staticClass: "soli-round",
                                attrs: { src: feature.img, eager: "" },
                              }),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "font-bold soli-grey pa-5" },
                                [
                                  _vm._v(
                                    "\n                        " +
                                      _vm._s(feature.text) +
                                      "\n                    "
                                  ),
                                ]
                              ),
                            ],
                            1
                          )
                        }),
                        1
                      ),
                    ]
                  },
                  proxy: true,
                },
                _vm.featureStep !== _vm.newFeatures.length
                  ? {
                      key: "cancelBtn",
                      fn: function (attrs) {
                        return [
                          _c(
                            "SoliBtn",
                            _vm._b(
                              {
                                attrs: {
                                  text: "Next",
                                  gradient: "gradient-blue",
                                },
                                on: {
                                  click: function ($event) {
                                    _vm.featureStep++
                                  },
                                },
                              },
                              "SoliBtn",
                              attrs,
                              false
                            )
                          ),
                        ]
                      },
                    }
                  : null,
              ],
              null,
              true
            ),
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.quickLinks
        ? _c("QuickLinks", {
            on: {
              reset: function ($event) {
                return _vm.closeQuickLinks()
              },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "v-snackbar",
        {
          attrs: {
            vertical: "",
            bottom: "",
            right: "",
            light: "",
            timeout: 6000,
            "content-class": "soli-grey pa-0",
          },
          scopedSlots: _vm._u([
            {
              key: "action",
              fn: function ({ attrs }) {
                return [
                  _c(
                    "v-btn",
                    _vm._b(
                      {
                        attrs: { color: "dark", rounded: "", text: "" },
                        on: {
                          click: function ($event) {
                            _vm.successCard.show = false
                          },
                        },
                      },
                      "v-btn",
                      attrs,
                      false
                    ),
                    [_vm._v("\n                Close\n            ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    _vm._b(
                      {
                        attrs: {
                          href: _vm.successCard.href,
                          color: "primary",
                          rounded: "",
                          text: "",
                        },
                      },
                      "v-btn",
                      attrs,
                      false
                    ),
                    [_vm._v("\n                View\n            ")]
                  ),
                ]
              },
            },
          ]),
          model: {
            value: _vm.successCard.show,
            callback: function ($$v) {
              _vm.$set(_vm.successCard, "show", $$v)
            },
            expression: "successCard.show",
          },
        },
        [
          _c("v-card-title", [_vm._v(_vm._s(_vm.successCard.title))]),
          _vm._v(" "),
          _c("v-card-subtitle", [_vm._v(_vm._s(_vm.successCard.subtitle))]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }